import { useEffect, useState } from 'react';
import {
  useNotification,
  getDataGridHeading,
  pageSizeChangeHandler,
} from 'utils/commonUtils';
import {
  tutoringSubjectsColumns,
  getTutoringSubjectsListData,
} from './getTutoringSubjectsListData';
import { useDispatch, useSelector } from 'react-redux';
import { intialPageSize } from 'constants';
import SubjectsAndTurorsDialog from './SubjectsAndTurorsDialog';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import {
  deleteTutoringSubject,
  getTimeSlot,
  getTutoringSubject,
  getTutoringSubjects,
} from 'layouts/tutoring/services/tutoringApi';
import CommonDeleteDialog from 'components/Common/CommonDeleteDialog/CommonDeleteDialog';
import SubjectsAndTutorsTimeSlotsDialog from './SubjectsAndTutorsTimeSlotsDialog';
import { getSubjects } from 'layouts/tutoring/store/subjectsSlice/subjectsSlice';

const SubjectsAndTutorsTab = () => {
  const dispatch = useDispatch();
  const { NotificationPopup, handleErrorResponse } = useNotification();
  const availableUsersList = useSelector((state) => state.availableUsersList);

  const [newSubject, setNewSubject] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [tutoringSubjectForm, setTutoringSubjectForm] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [timeSlotData, setTimeSlotData] = useState([]);
  const [selectedSubjectId, setSelectedSubjectId] = useState(null);
  const [openSubjectsAndTurorsDialog, setOpenSubjectsAndTurorsDialog] =
    useState(false);
  const [
    openSubjectsAndTutorsTimeSlotsDialog,
    setSubjectsAndTutorsTimeSlotsDialog,
  ] = useState(false);
  const [tutoringSubjects, setTutoringSubjects] = useState({
    isLoading: false,
    rows: [],
    pageSize: intialPageSize,
    page: 1,
  });

  useEffect(() => {
    fetchTutoringSubjects();
    setNewSubject(false);
  }, []);

  const fetchTutoringSubjects = async () => {
    try {
      setTutoringSubjects((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const subjectAndTutorsData = await getTutoringSubjects();
      dispatch(getSubjects(subjectAndTutorsData));
      setTutoringSubjects((prev) => ({
        ...prev,
        isLoading: false,
        rows: getTutoringSubjectsListData(
          subjectAndTutorsData,
          availableUsersList
        ),
      }));
    } catch (error) {
      setTutoringSubjects((prev) => ({
        ...prev,
        isLoading: false,
      }));
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const pageSizeChange = pageSizeChangeHandler(setTutoringSubjects);

  const handleEdit = async (params) => {
    try {
      setIsFormLoading(true);
      const subjectId = params?.row?.subjectId;
      const getData = await getTutoringSubject(subjectId);
      setTutoringSubjectForm(getData);
      setOpenSubjectsAndTurorsDialog(true);
      setIsFormLoading(false);
    } catch (error) {
      setIsFormLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleDelete = async (params) => {
    const subjectId = params?.row?.subjectId;
    setOpenDeleteDialog(true);
    setSelectedSubjectId(subjectId);
  };

  const handleViewTimeSlots = async (params) => {
    const subjectId = params?.row?.subjectId;
    try {
      setIsFormLoading(true);
      const data = await getTimeSlot(subjectId);
      setTimeSlotData(data);
      setIsFormLoading(false);
      setSubjectsAndTutorsTimeSlotsDialog(true);
    } catch (error) {
      setIsFormLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleNewSubject = async () => {
    setNewSubject(true);
    setOpenSubjectsAndTurorsDialog(true);
  };

  return (
    <>
      {getDataGridHeading('', 'New Subject', handleNewSubject)}
      <DeltaDataGrid
        listData={tutoringSubjects}
        columns={tutoringSubjectsColumns(
          handleEdit,
          handleDelete,
          handleViewTimeSlots
        )}
        setListData={pageSizeChange}
      />
      <SubjectsAndTurorsDialog
        newSubject={newSubject}
        setNewSubject={setNewSubject}
        isFormLoading={isFormLoading}
        open={openSubjectsAndTurorsDialog}
        setOpen={setOpenSubjectsAndTurorsDialog}
        tutoringSubjectForm={tutoringSubjectForm}
        fetchTutoringSubjects={fetchTutoringSubjects}
        setTutoringSubjectForm={setTutoringSubjectForm}
      />
      <SubjectsAndTutorsTimeSlotsDialog
        timeSlotData={timeSlotData}
        isFormLoading={isFormLoading}
        open={openSubjectsAndTutorsTimeSlotsDialog}
        setOpen={setSubjectsAndTutorsTimeSlotsDialog}
      />
      <CommonDeleteDialog
        snakBarName="Subject"
        fetchData={fetchTutoringSubjects}
        commonDeleteId={selectedSubjectId}
        openDeleteDialog={openDeleteDialog}
        commonDeleteApi={deleteTutoringSubject}
        setOpenDeleteDialog={setOpenDeleteDialog}
        contentText="Are you sure you want to delete this subject ?"
      />
      <NotificationPopup />
    </>
  );
};

export default SubjectsAndTutorsTab;
